import React from "react";
import {
  Box, List, ListItemButton, ListItemIcon, ListItemText,
  Typography, Divider, Chip,
} from "@mui/material";
import {
  Dashboard, Hub, Cable, Receipt, History, Palette, Settings,
  Add as AddIcon,
} from "@mui/icons-material";

const MENU_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: Dashboard },
  { id: "connections", label: "Canais", icon: Cable },
  { id: "hubs", label: "HUBs Locais", icon: Hub },
  { id: "billing", label: "Billing", icon: Receipt },
  { id: "logs", label: "Logs", icon: History },
  { id: "whitelabel", label: "White Label", icon: Palette },
  { id: "settings", label: "Configuracoes", icon: Settings },
];

export default function Sidebar({ currentPage, onPageChange, onOpenHub, tenant }) {
  return (
    <Box
      sx={{
        width: 240,
        minHeight: "100vh",
        bgcolor: "#0D1117",
        borderRight: "1px solid rgba(255,255,255,0.06)",
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 1200,
      }}
    >
      {/* Logo */}
      <Box sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          component="img"
          src="/logo.png"
          alt="OtimizAPP HUB"
          sx={{ width: 40, height: 40, borderRadius: 1.5, objectFit: "cover" }}
        />
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#fff", lineHeight: 1.2 }}>
            OtimizAPP
          </Typography>
          <Typography sx={{ fontSize: 11, color: "#6B7280", lineHeight: 1.2 }}>
            Connect
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />

      {/* Tenant */}
      {tenant && (
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography sx={{ fontSize: 11, color: "#6B7280", textTransform: "uppercase", letterSpacing: 1 }}>
            Tenant
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#D1D5DB", fontWeight: 500 }}>
            {tenant.name}
          </Typography>
        </Box>
      )}

      <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />

      {/* Menu */}
      <List sx={{ flex: 1, py: 1 }}>
        {MENU_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = currentPage === item.id;

          return (
            <ListItemButton
              key={item.id}
              selected={isActive}
              onClick={() => onPageChange(item.id)}
              sx={{
                mx: 1, borderRadius: 2, mb: 0.5,
                "&.Mui-selected": {
                  bgcolor: "rgba(107, 72, 255, 0.15)",
                  "&:hover": { bgcolor: "rgba(107, 72, 255, 0.2)" },
                },
                "&:hover": { bgcolor: "rgba(255,255,255,0.05)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Icon sx={{ fontSize: 20, color: isActive ? "#6B48FF" : "#6B7280" }} />
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: 13, fontWeight: isActive ? 600 : 400,
                  color: isActive ? "#fff" : "#9CA3AF",
                }}
              />
            </ListItemButton>
          );
        })}
      </List>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />

      {/* Nova Conexão */}
      <Box sx={{ p: 2 }}>
        <ListItemButton
          onClick={onOpenHub}
          sx={{
            borderRadius: 2,
            bgcolor: "rgba(107, 72, 255, 0.1)",
            border: "1px solid rgba(107, 72, 255, 0.3)",
            "&:hover": { bgcolor: "rgba(107, 72, 255, 0.2)" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <AddIcon sx={{ fontSize: 18, color: "#6B48FF" }} />
          </ListItemIcon>
          <ListItemText
            primary="Nova Conexao"
            primaryTypographyProps={{ fontSize: 13, fontWeight: 600, color: "#6B48FF" }}
          />
        </ListItemButton>
      </Box>
    </Box>
  );
}
